<template>
  <div class="lesson" v-for="item in booksList" :key="item._id">
    <h4>请确认商品信息</h4>
    <div class="video">
      <div class="detail">
        <div class="pic">
          <img v-lazy="item.coverImg" alt="" />

          <div class="name">
            <h4>
              {{ item.booksTitle }}
            </h4>
          </div>
        </div>
        <div class="con-video">
          <h4>出版社</h4>
          <div class="video-item">
            <i>{{ item.press }} </i>
          </div>
        </div>
        <div class="con-pdf">
          <h4>作者</h4>
          <div class="video-item">
            <i>{{ item.booksAuthor }}</i>
          </div>
        </div>
        <div class="con-service">
          <h4>适用专业</h4>
          <div class="video-item">
            <i class="iserve">{{ item.shclass[0]?.clName }}</i>
          </div>
        </div>
        <div class="con-price">
          <h4>单价</h4>
          <div class="video-item price">
            <p>&yen; {{ item.salePrice }}</p>
          </div>
        </div>
        <div class="con-count">
          <h4>数量</h4>
          <div class="video-item">
            <p>{{ $route.query.num }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="notice">
      <p>备注留言：</p>
      <el-input
        v-model="notice"
        style="width: 360px"
        :rows="2"
        type="textarea"
        placeholder="请备注留言"
      />
    </div>
    <div class="check">
      <h3>总价：{{ item.salePrice * parseInt($route.query.num) }}</h3>

      <p
        v-show="isConfirm"
        @click="
          checkConfirm({
            booksID: item._id,
            salePrice: item.salePrice * parseInt($route.query.num),
            booksNum: $route.query.num,
            booksTitle: item.booksTitle,
            press: item.press,
            booksAuthor: item.booksAuthor,
          })
        "
      >
        <el-button type="danger">点击确认</el-button>
      </p>
      <p v-show="!isConfirm">
        <el-button type="danger" disabled>点击确认</el-button>
      </p>
    </div>
  </div>
</template>

<script>
import { ref, computed, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { findBooksCheckOut } from "@/api/books";
import { createBooksOrder } from "@/api/order";
import { updateUserMaID } from "@/api/user";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const booksList = ref([]);
    const notice = ref("");
    const isConfirm = ref(true);
    const store = useStore();
    let timer;
    findBooksCheckOut(route.query.id)
      .then((data) => {
        booksList.value = data;
      })
      .catch((error) => {
        console.log(error);
      });
    //计算并获取登录后用户信息数据
    const profile = computed(() => {
      return store.state.user.profile;
    });
    //提交、创建图书订单
    const checkConfirm = (order) => {
      const { booksID, salePrice, booksNum, booksTitle, press, booksAuthor } =
        order;
      const params = {
        booksID,
        salePrice,
        booksNum: parseInt(booksNum),
        booksTitle,
        press,
        booksAuthor,
        userID: profile.value._id,
        nickName: profile.value.nickName,
        phone: profile.value.phone,
        notice: notice.value,
      };
      createBooksOrder(params)
        .then((data) => {
          if (data.code == 200 && data.order) {
            ElMessage({
              message: data.msg,
              type: "success",
            });
            isConfirm.value = false;
            router.push(`/user/pay?orderID=${data.order}`);

            //router.push(`/user/pay?orderID=${data.vorderID}`);
          } else {
            ElMessage({
              message: "订单创建失败",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      updateUserMaID({ maID: params.maID, userID: profile.value._id })
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    return { booksList, checkConfirm, profile, notice, isConfirm };
  },
};
</script>

<style lang="less" scoped>
.lesson {
  margin: 35px auto;
  width: 1240px;
  min-height: 570px;
  background: #fefefe;
  border-radius: 8px;
  h4 {
    text-align: center;
    padding-top: 15px;
  }
  .video {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1200px;
    //height: 280px;
    margin: 15px auto;
    //background: #999;
    border-radius: 8px;
    border: 1px solid #e4e4e4;
    .detail {
      position: relative;
      margin: 8px 8px 8px 8px;
      width: 1180px;
      //height: 260px;
      display: flex;
      align-items: center;
      .pic {
        width: 312.5px;
        position: relative;
        img {
          width: 312.5px;
          height: 209.5px;
          border-radius: 8px;
        }
        .grade {
          position: absolute;
          font-weight: bold;
          font-size: 18px;
          top: 61%;
          left: 40%;
        }
        .grade1 {
          position: absolute;
          font-weight: bold;
          font-size: 20px;
          top: 60%;
          left: 34%;
        }
        .name {
          width: 312.5px;
          h4 {
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
      .con-video {
        width: 230px;
        h4 {
          display: block;
          position: absolute;
          top: -15px;
          left: 395px;
        }
        .video-item {
          height: 100%;
          min-height: 263.69px;
          margin-left: 8px;
          margin-top: 25px;
          border-radius: 8px;
          border: 1px solid #e4e4e4;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-around;
          i {
            display: block;
            padding-left: 5px;
            padding-right: 5px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin: 3px 3px 3px 3px;
            color: #409eff;
            background-color: #ecf5ff;
            border-radius: 5px;
          }

          span {
            margin: 3px 3px 3px 3px;
          }
        }
      }
      .con-pdf {
        width: 180px;
        h4 {
          //display: block;
          position: absolute;
          top: -15px;
          left: 595px;
        }
        .video-item {
          height: 100%;
          min-height: 263.69px;
          margin-left: 8px;
          border-radius: 8px;
          margin-top: 25px;
          border: 1px solid #e4e4e4;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-around;
          i {
            display: block;
            padding-left: 5px;
            padding-right: 5px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin: 3px 3px 3px 3px;
            color: #67c23a;
            background-color: #f0f9eb;
            border-radius: 5px;
          }
          span {
            margin: 3px 3px 3px 3px;
          }
        }
      }
      .con-service {
        width: 180px;
        h4 {
          //display: block;
          position: absolute;
          top: -15px;
          left: 775px;
        }
        .video-item {
          height: 100%;
          min-height: 263.69px;
          margin-left: 8px;
          margin-top: 25px;
          border-radius: 8px;
          border: 1px solid #e4e4e4;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-around;
          .iserve {
            display: block;
            padding-left: 5px;
            padding-right: 5px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin: 3px 3px 3px 3px;
            color: #f56c6c;
            background-color: #fef0f0;
            border-radius: 5px;
          }
          .service {
            display: block;
            padding-left: 5px;
            padding-right: 5px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            margin: 3px 3px 3px 3px;
            color: #e6a23c;
            background-color: #fdf6ec;
            border-radius: 5px;
          }
          span {
            margin: 3px 3px 3px 3px;
          }
        }
      }
      .con-price {
        width: 150px;
        h4 {
          //display: block;
          position: absolute;
          top: -15px;
          right: 210px;
        }
        .video-item {
          height: 100%;
          min-height: 263.69px;
          margin-left: 8px;
          border-radius: 8px;
          margin-top: 25px;
          border: 1px solid #e4e4e4;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-around;

          span {
            margin: 3px 3px 3px 3px;
          }
        }
      }
      .con-count {
        width: 150px;
        h4 {
          //display: block;
          position: absolute;
          top: -15px;
          right: 70px;
        }
        .video-item {
          height: 100%;
          min-height: 263.69px;
          margin-left: 8px;
          border-radius: 8px;
          margin-top: 25px;
          border: 1px solid #e4e4e4;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-around;

          span {
            margin: 3px 3px 3px 3px;
          }
        }
      }
      .price {
        min-height: 263.69px;
        display: flex;
        color: red;
        justify-content: center;
        p {
          line-height: 263.69px;
        }
      }
    }
  }

  .check {
    width: 180px;
    //height: 180px;
    //background: #dddbdb;
    float: right;
    h3 {
      color: red;
    }
    p {
      margin-top: 30px;
    }
  }
  .notice {
    //width: 800px;
    margin-left: 20px;
    display: flex;
    align-items: center;
  }
}
</style>
